<template>
  <div>
    <vue-headful
      title="Projects"
      description="Mathew Moose - Software Engineer. This is a portfolio site used to showcase some of my work."
    />
<section class="section">
  <h1 class="title">Projects</h1>
    <div class="tile is-ancestor">
  <div class="tile is-vertical is-8">
    <div class="tile is-parent">
      <article class="tile is-child notification is-primary">
          <p class="title">Web Pages</p>
          <p class="subtitle">Production Sites and Live Demos</p>
      </article>
    </div>
    <div class="tile">
      <div class="tile is-parent">
        <article class="tile is-child notification is-primary">
          <p class="title has-text-centered">Digital Media</p>
          <p class="subtitle has-text-centered">Project Compilation</p>
          <figure class="image is-2by1">
            <img :src="require('@/assets/Digital-Media-Laptop.png')" class="float"/>
          </figure>
          <div class="tile-controls">
            <div class="is-grouped">
              <a class="button is-info" href="Digital-Media" target="_blank">View</a>
            </div>
          </div>
        </article>
      </div>
      <div class="tile is-parent is-vertical">
        <article class="tile is-child notification is-primary">
          <p class="title has-text-centered">Varner Auto</p>
          <p class="subtitle has-text-centered">Business Website</p>
          <figure class="image is-2by1">
            <img :src="require('@/assets/Varner-Auto-Laptop.png')" class="float"/>
          </figure>
          <div class="tile-controls">
            <div>
              <a class="button is-info" href="http://varnerauto.com/" target="_blank">View</a>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="tile">
      <div class="tile is-parent is-vertical">
        <article class="tile is-child notification is-primary">
          <p class="title has-text-centered">RNG Math Game</p>
          <p class="subtitle has-text-centered">Algorithm Game</p>
          <figure class="image is-2by1">
            <img :src="require('@/assets/Calculator-Laptop.png')" class="float"/>
          </figure>
          <div class="tile-controls">
            <div class="is-grouped">
              <a class="button is-info" href="https://github.com/XMoose25X/Randomly-Generated-Math-Game" target="_blank">
                <span class="icon">
                  <font-awesome-icon :icon="['fab', 'github']"/>
                </span>
                <span>Code</span>
              </a>
              <a class="button is-info" href="https://xmoose25x.github.io/Randomly-Generated-Math-Game/" target="_blank">View</a>
            </div>
          </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification is-primary">
          <p class="title has-text-centered">Switch Controller DB</p>
          <p class="subtitle has-text-centered">Retired Web Scraper</p>
          <figure class="image is-2by1">
            <img :src="require('@/assets/Switch-Laptop.png')" class="float"/>
          </figure>
          <div class="tile-controls">
            <div class="is-grouped">
              <a class="button is-info" href="https://github.com/XMoose25X/Nintendo-Switch-Controller-DB" target="_blank">
                <span class="icon">
                  <font-awesome-icon :icon="['fab', 'github']"/>
                </span>
                <span>Code</span>
              </a>
              <a class="button is-info" href="https://xmoose25x.github.io/Nintendo-Switch-Controller-DB/" target="_blank">View</a>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="tile">
      <div class="tile is-parent">
        <article class="tile is-child notification is-primary">
          <p class="title has-text-centered">Moosify</p>
          <p class="subtitle has-text-centered">Website Remix</p>
          <figure class="image is-2by1">
            <img :src="require('@/assets/Moosify.gif')" class="gif"/>
          </figure>
          <div class="tile-controls">
            <div class="is-grouped">
              <a class="button is-info" href="https://github.com/XMoose25X/Moosify" target="_blank">
                <span class="icon">
                  <font-awesome-icon :icon="['fab', 'github']"/>
                </span>
                <span>Code</span>
              </a>
              <a class="button is-info" href="https://xmoose25x.github.io/Moosify/" target="_blank">View</a>
            </div>
          </div>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification is-primary">
          <p class="title has-text-centered">Valentine's Day</p>
          <p class="subtitle has-text-centered">Virtual Card</p>
          <figure class="image is-2by1">
            <img :src="require('@/assets/ValentinesDay.gif')" class="gif"/>
          </figure>
          <div class="tile-controls">
            <div class="is-grouped">
              <a class="button is-info" href="https://github.com/XMoose25X/Valentines-Day" target="_blank">
                <span class="icon">
                  <font-awesome-icon :icon="['fab', 'github']"/>
                </span>
                <span>Code</span>
              </a>
              <a class="button is-info" href="https://xmoose25x.github.io/Valentines-Day/" target="_blank">View</a>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
  <div class="tile is-parent is-vertical">
    <div class="tile is-parent">
      <article class="tile is-child notification is-success">
          <p class="title">Video Games</p>
          <p class="subtitle">Group Game Jam Projects</p>
      </article>
    </div>
    <div class="tile is-parent">
        <article class="tile is-child notification is-success">
          <p class="title has-text-centered">Dungeoneer</p>
          <p class="subtitle has-text-centered">(You are NOT the hero)</p>
          <figure class="image is-2by1">
            <img :src="require('@/assets/Dungeoneer.gif')" class="gif"/>
          </figure>
          <div class="tile-controls">
            <div class="is-grouped">
              <a class="button is-info" href="https://itch.io/jam/bored-pixels-jam-8/rate/1130803" target="_blank">
                <span class="icon">
                  <font-awesome-icon :icon="['fab', 'itch-io']"/>
                </span>
                <span>Jam Submission</span>
              </a>
              <a class="button is-info" href="https://saltmonger.itch.io/dungeoneer" target="_blank">Play</a>
            </div>
          </div>
        </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child notification is-warning">
          <p class="title">Desktop Applications</p>
          <p class="subtitle">Programming Utilities</p>
      </article>
    </div>
    <div class="tile is-parent">
      <article class="tile is-child notification is-warning">
        <div class="content">
          <p class="title">WixWizard</p>
          <p class="subtitle">Installer Generation</p>
          <div class="content">
            <figure class="image is-2-by-1">
              <img :src="require('@/assets/WixWizard.png')"/>
              <div class="overlay">
                <div class="overlay-text">Coming Soon™!</div>
              </div>
            </figure>
          </div>
        </div>
      </article>
    </div>
  </div>
</div>
</section>

  </div>
</template>
<script>
export default {
  name: 'Home',
  data: function () {
    return {
      msg: 'About Mathew',
      base: window.location.href
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.67);
}
.overlay-text {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-15deg);
  -ms-transform: translate(-50%, -50%) rotate(-15deg);
  text-align: center;
}

  .fa-icon{
    color: cyan;
    margin-bottom: 5px;
  }
  a {
    color: cyan;
    text-decoration: none;
  }
  #tags{
    position: absolute;
    display: inline;
    right: 9999px;
  }
  .tag-image {
    height:1px;
    width:1px;
  }
  .tile-controls{
    display: flex;
    justify-content: flex-end;
  }
  .gif{
    padding-bottom: 1em;
    border-radius: 25px;
  }
  .float{
    animation: float 6s ease-in-out infinite;
  }
  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(-10px);
    }
    100% {
      transform: translatey(0px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectsPage.vue